import { render, staticRenderFns } from "./BasicLayoutV.vue?vue&type=template&id=8c2d64b8&scoped=true"
import script from "./BasicLayoutV.vue?vue&type=script&lang=js"
export * from "./BasicLayoutV.vue?vue&type=script&lang=js"
import style0 from "./BasicLayoutV.vue?vue&type=style&index=0&id=8c2d64b8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c2d64b8",
  null
  
)

export default component.exports